import React from 'react';
import { AlertTriangle, MoreHorizontal, Phone, Mail } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { Avatar } from '../ui/Avatar';
import { Button } from '../ui/Button';
interface Student {
  id: string;
  name: string;
  avatar?: string;
  riskLevel: 'high' | 'medium' | 'low';
  lastVisit: string;
  frequencyDrop: string;
}
const mockStudents: Student[] = [{
  id: '1',
  name: 'Ana Silva',
  riskLevel: 'high',
  lastVisit: '15 dias atrás',
  frequencyDrop: '-80%'
}, {
  id: '2',
  name: 'Carlos Oliveira',
  riskLevel: 'medium',
  lastVisit: '8 dias atrás',
  frequencyDrop: '-40%'
}, {
  id: '3',
  name: 'Mariana Santos',
  riskLevel: 'medium',
  lastVisit: '7 dias atrás',
  frequencyDrop: '-35%'
}, {
  id: '4',
  name: 'Pedro Costa',
  riskLevel: 'high',
  lastVisit: '21 dias atrás',
  frequencyDrop: '-100%'
}, {
  id: '5',
  name: 'Julia Lima',
  riskLevel: 'low',
  lastVisit: '4 dias atrás',
  frequencyDrop: '-15%'
}];
export function RiskList() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-45">
      <div className="p-6 border-b border-gray-200 flex justify-between items-center" data-id="element-46">
        <h3 className="font-bold text-lg text-gray-800" data-id="element-47">Alunos em Risco</h3>
        <Button variant="ghost" size="sm" data-id="element-48">
          Ver Todos
        </Button>
      </div>
      <div className="overflow-x-auto" data-id="element-49">
        <table className="w-full text-left text-sm" data-id="element-50">
          <thead className="bg-gray-50 text-gray-500" data-id="element-51">
            <tr data-id="element-52">
              <th className="px-6 py-3 font-medium" data-id="element-53">Aluno</th>
              <th className="px-6 py-3 font-medium" data-id="element-54">Risco</th>
              <th className="px-6 py-3 font-medium" data-id="element-55">Última Visita</th>
              <th className="px-6 py-3 font-medium" data-id="element-56">Queda Freq.</th>
              <th className="px-6 py-3 font-medium text-right" data-id="element-57">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-58">
            {mockStudents.map(student => <tr key={student.id} className="hover:bg-gray-50 transition-colors" data-id="element-59">
                <td className="px-6 py-4" data-id="element-60">
                  <div className="flex items-center gap-3" data-id="element-61">
                    <Avatar src={student.avatar} alt={student.name} size="sm" data-id="element-62" />
                    <span className="font-medium text-gray-900" data-id="element-63">
                      {student.name}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-64">
                  <Badge variant={student.riskLevel === 'high' ? 'danger' : student.riskLevel === 'medium' ? 'warning' : 'success'} data-id="element-65">
                    {student.riskLevel === 'high' ? 'Crítico' : student.riskLevel === 'medium' ? 'Atenção' : 'Baixo'}
                  </Badge>
                </td>
                <td className="px-6 py-4 text-gray-600" data-id="element-66">{student.lastVisit}</td>
                <td className="px-6 py-4 text-red-500 font-medium" data-id="element-67">
                  {student.frequencyDrop}
                </td>
                <td className="px-6 py-4 text-right" data-id="element-68">
                  <div className="flex justify-end gap-2" data-id="element-69">
                    <button className="p-1.5 text-gray-400 hover:text-[var(--primary)] hover:bg-orange-50 rounded-md transition-colors" title="Ligar" data-id="element-70">
                      <Phone size={16} data-id="element-71" />
                    </button>
                    <button className="p-1.5 text-gray-400 hover:text-[var(--primary)] hover:bg-orange-50 rounded-md transition-colors" title="Mensagem" data-id="element-72">
                      <Mail size={16} data-id="element-73" />
                    </button>
                    <button className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors" data-id="element-74">
                      <MoreHorizontal size={16} data-id="element-75" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}